<template>
  <router-view />
</template>

<script>
  export default {
    name: 'NestedRouteComponent'
  };
</script>
